import type { EmployeeDto, ScheduleDayDto, DayOfWeek } from '@/services/api/petseo.client';
import type { SelectOption } from '@petseo/shared';
import { DAYS_ORDER } from '@/utils/datetime';

export function getEmployeeOptions(employees?: EmployeeDto[], showPosition = false): SelectOption[] {
  if (!employees) return [];

  return employees.map((e) => ({
    value: String(e.id),
    label: showPosition && e.position ? `${e.firstName} ${e.lastName} (${e.position})` : `${e.firstName} ${e.lastName}`,
  }));
}

export function buildWeekDays(days?: ScheduleDayDto[]): { dayOfWeek: DayOfWeek; day?: ScheduleDayDto }[] {
  const dayMap = new Map((days ?? []).map((d) => [d.dayOfWeek!, d]));
  return DAYS_ORDER.map((dow) => ({ dayOfWeek: dow, day: dayMap.get(dow) }));
}
